"use client"
import classNames from "classnames"
import styles from "../../styles/LandingPage/Patients.module.scss"
import ModalContent from "./LandingPage/ModalContent"
import { Dialog } from "@mui/material"
import { Fragment, useState } from "react"
import skColors from "../../styles/skColors"
import Link from "next/link"
import StyledText from "../typography/typography-component"
import { useTranslations } from "next-intl"
import { Routes } from "../data/routes"
import { TrackedActions } from "../tracking/trackedActions"

const Footer = () => {
  const [show, setShow] = useState(false)
  const t = useTranslations("index.footer")

  return (
    <div className={styles.footerGroup}>
      <Fragment key={"footer"}>
        <footer id={"contact"} className={classNames(styles.footer)}>
          <div className={styles.certificationBanner}>
            <div className={styles.certIconGroup}>
              <img src="/svg/certified.svg" alt={t("certAlt")} />
              <StyledText variant="h6" color={skColors.darkgreen[600]}>
                0425
              </StyledText>
            </div>
            <StyledText variant="pSmall" className={styles.certText} color={skColors.darkgreen[600]}>
              {t("certText")}
            </StyledText>
          </div>

          <div className={styles.footerBottom}>
            <StyledText
              style={{ fontSize: "14px" }}
              color={skColors.darkgreen[600]}
              variant="pSmall"
              className={styles.footerCopyright}
            >
              {t("copyright", { year: new Date().getFullYear() })}
            </StyledText>
            <div className={styles.footerLinks}>
              <a onClick={() => void TrackedActions.goToSelfCheck()}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.selfcheck")}
                </StyledText>
              </a>

              <Link href={Routes.ratgeber}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.guide")}
                </StyledText>
              </Link>

              <Link href={Routes.aboutUs}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.aboutUs")}
                </StyledText>
              </Link>

              <Link href={Routes.team}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.team")}
                </StyledText>
              </Link>

              <Link href={Routes.doctors}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.doctors")}
                </StyledText>
              </Link>

              <Link href={"/pdfs/privacy.pdf"} locale={false}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.privacy")}
                </StyledText>
              </Link>
              <Link href={"/pdfs/Datenschutzerklaerung_App.pdf"} locale={false}>
                <StyledText className={styles.footerLink} color={skColors.darkgreen[500]} variant={"pSmall"}>
                  {t("links.privacy_app")}
                </StyledText>
              </Link>

              <StyledText
                className={styles.footerLink}
                color={skColors.darkgreen[500]}
                variant={"pSmall"}
                onClick={() => setShow(true)}
              >
                {t("links.imprint")}
              </StyledText>
            </div>
          </div>
        </footer>

        <Dialog open={show} onClose={() => setShow(false)} className={styles.modal}>
          <ModalContent onClose={() => setShow(false)} />
        </Dialog>
      </Fragment>
    </div>
  )
}

export default Footer
